export default {
  getPrizeList () {
    return {
      returncode: 0,
      message: '',
      result: [
      {
        id: 1,
        name: '111',
        img: './prize/p1.png'
        // img: require("@images/lottery/prize/1.png")
      },
      {
        id: 2,
        name: '222',
        img: './prize/p2.png'
      },
      {
        id: 3,
        name: '333',
        img: './prize/p3.png'
      },
      {
        id: 4,
        name: '444',
        img: './prize/p4.png'
      },
      {
        id: 5,
        name: '555',
        img: './prize/p5.png'
      },
      {
        id: 6,
        name: '666',
        img: './prize/p6.png'
      },
      {
        id: 7,
        name: '777',
        img: './prize/p7.png'
      },
      {
        id: 8,
        name: '888',
        img: './prize/p8.png'
      }
      ]
    }
  },
  lottery () {
    return {
      returncode: 0,
      message: '',
      result: {
        iswin: 0,
        id: 1,
        name: '测试',
        img: './prize/p1.png'
      }
    }
  }
}
